import { Pause, Play } from 'lucide-react'
import { toggleAudio, useAudio } from '../lib/audio.ts'

/**
 * Play/pause pill bound to the global player. `what` completes the accessible name: "Putar ayat 5" / "Jeda ayat 5".
 * `compact` = round icon-only button (tight headers).
 */
export function AudioButton({ id, srcs, what, compact = false, className = '' }: { id: string; srcs: string[]; what: string; compact?: boolean; className?: string }) {
  const a = useAudio()
  const on = a.id === id && a.playing
  return (
    <button type="button" className={`audio-pill${on ? ' on' : ''}${compact ? ' compact' : ''} ${className}`} onClick={() => toggleAudio(id, srcs)} aria-label={`${on ? 'Jeda' : 'Putar'} ${what}`}>
      {on ? <Pause size={compact ? 20 : 16} aria-hidden="true" /> : <Play size={compact ? 20 : 16} aria-hidden="true" />}
      {!compact && <span aria-hidden="true">{on ? 'Jeda' : 'Dengar'}</span>}
    </button>
  )
}
